export default (sku) => {
  switch (sku.toUpperCase()) {
    case "SS":
      return "Sterling Silver"
    case "KW":
    case "10KW":
    case "14KW":
    case "18KW":
      return "White Gold"
    case "KY":
    case "10KY":
    case "14KY":
    case "18KY":
      return "Yellow Gold"
    case "KR":
    case "10KR":
    case "14KR":
    case "18KR":
      return "Rose Gold"
    case "10KT":
    case "14KT":
      return "Tri-color Gold"
    case "SSKYP":
    case "SS14KYP":
    case "SS18KYP":
      return "Gold Plated Silver"
    case "SSRGP":
      return "Rose Gold Plated"
    case "VERMY":
      return "Vermeil"
    case "TUNG":
      return "Tungsten"
    case "COB":
      return "Cobalt"
    case "CER":
      return "Ceramic"
    case "SST":
      return "Stainless Steel"
    case "SST18KYP":
      return "Gold Plated Stainless Steel"
    case "TSS":
      return "Tungsten & Sterling Silver"
    case "T10KW":
    case "T14KW":
    case "T18KW":
      return "Tungsten & White Gold"
    case "T10KY":
    case "T14KY":
    case "T18KY":
      return "Tungsten & Yellow Gold"
    case "T10KR":
    case "T14KR":
    case "T18KR":
      return "Tungsten & Rose Gold"
  }

  return null
}

export const mapMetalClass = (sku, bg = true) => {
  const metal = sku.replace(/[0-9]/g, "").toLowerCase()
  switch (metal) {
    case "ss":
    case "sst":
    case "sstkyp":
    case "tss":
    case "vermy":
    case "sskyp":
      return bg ? "bg-sku-ss" : "text-sku-ss"
    case "kw":
    case "trw":
      return bg ? "bg-sku-kw" : "text-sku-kw"
    case "ky":
    case "tky":
      return bg ? "bg-sku-ky" : "text-sku-ky"
    case "kr":
    case "tkr":
      return bg ? "bg-sku-kr" : "text-sku-kr"
    case "tung":
      return bg ? "bg-sku-tung" : "text-sku-tung"
    case "cob":
      return bg ? "bg-sku-cob" : "text-sku-cob"
    default:
      return bg ? "bg-sku-cer" : "text-sku-cer"
  }
}

const SOLID_GOLD_SKUS = [
  "10KW",
  "10KY",
  "10KR",
  "14KW",
  "14KY",
  "14KR",
  "18KW",
  "18KY",
  "18KR",
]

export const isSolidGold = (sku) => SOLID_GOLD_SKUS.includes(sku)
